<template>
<button :type="type" class="swaychat-button" @click="triggerClick" :class="{
        'swaychat-button-expand': expand,
        'swaychat-button-outline': outline
      }" :style="{
        'background-color': primary ? primaryBg : 'white',
        'border-color': outline ? primaryBg : '',
        'color': outline ? primaryBg : ''
        }">
      {{ label }}
  </button>
</template>

<script>

import Path from 'object-path'

export default {
  props: [
    'label',
    'expand',
    'primary',
    'outline',
    'type'
  ],
  computed: {
    primaryBg() {
      return this.$store.getters.getPrimaryBg
    }
  },
  methods: {
    triggerClick() {
      this.$emit('click')
    }
  }
}
</script>
